/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import styled from "styled-components";
import { Input2, DropDown2, DecimalInput } from "components";
import AutocompleteFreeText from "components/AutocompleteFreeText";
import { useInput } from "hooks";
import { ALL_COUPON_TYPES_TEXT_PREFIXED, SAVE_OFFER_PREDICTIVE_TEXT } from "config";
import { Select, Tag } from "antd";
export const OfferBOGOTextBuilder = ({
  className,
  value = "",
  onChange = () => {},
}) => {
  const buy = useInput("1");
  const get = useInput("1");
  const val = useInput("");
  const type = useInput("Free");
  const wPurchase = useInput("");
  const purchaseAmount = useInput("");
  const typeData = [
    { id: "%", title: "%" },
    { id: "% off", title: "% off" },
    { id: "$", title: "$" },
    { id: "$ off", title: "$ off" },
    { id: "Free", title: "Free" },
  ];
  const freeText = useInput("");
  const couponText = useInput("");
  const amountDataTypes = ["$", "$ off"];

  const handleUpdateValue = (b, g, v, t, free_text, coupon_text) => {
    const purchaseMatch = value.match(/w\/purchase\/\S+(?:\s+\d+(?:\.\d+)?)?/);
    const purchaseText = purchaseMatch ? `${purchaseMatch[0]}` : '';
    console.log({b, g, v, t, free_text, coupon_text, purchaseText});
    // Build the parts array, filtering out empty strings
    const buildOfferText = (prefix, ...parts) => {
      return [prefix, ...parts].filter(p => p && p.trim()).join(' ');
    };
    
    switch (t) {
      case "Free":
        onChange(buildOfferText(`B${b}G${g}F`, purchaseText, free_text, coupon_text));
        get?.setValue(g)
        val.setValue("");
        type.setValue("Free")
        break;
      case "%":
        onChange(buildOfferText(`B${b}G${g} ${v}%`, purchaseText, free_text, coupon_text));
        get?.setValue(g)
        type.setValue("%")
        break;
      case "% off":
        onChange(buildOfferText(`B${b}G${g} ${v}% off`, purchaseText, free_text, coupon_text));
        get?.setValue(g)
        type.setValue("% off")
        break;
      case "$":
        onChange(buildOfferText(`B${b}G${g} $${v}`, purchaseText, free_text, coupon_text));
        get?.setValue(g)
        type.setValue("$")
        break;
      case "$ off":
        onChange(buildOfferText(`B${b}G${g} $${v} off`, purchaseText, free_text, coupon_text));
        get?.setValue(g)
        type.setValue("$ off")
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (value) {
      let [bogo, valueType, ...text] = value.split(" ");
      text = text.join(" ");
      let v = ''
      let t = 'Free'
      // Set BOGO Values
      const getIndex = bogo.indexOf('G');
      if (getIndex) {
        let buyVal = bogo.slice(1, getIndex);
        let getVal = bogo.slice(getIndex + 1, bogo.length);
        if (getVal.endsWith('F')){
          t = 'Free'
          getVal = getVal.replace('F', '')
        }
        buy.setValue(buyVal);
        get.setValue(getVal);
      }
      // Set Value, type and Free Text
      if (valueType) {
        if (valueType.endsWith('%')) {
          if (text.startsWith('off')) {
            v = valueType.replace('%', '');
            text = text.replace('off', '');
            t = '% off'
          }
          else {
            v = valueType.replace('%', '');
            t = '%';
          }
        }
        else if (valueType.endsWith('off')) {
          v = valueType.replace('off', '');
          v = valueType.replace('$', '');
          t = 'off'
        }
        else if (valueType.startsWith('$')) {
          if (text.startsWith('off')) {
            v = valueType.replace('off', '');
            v = valueType.replace('$', '');
            text = text.replace('off', '');
            t = '$ off'
          } else {
            v = valueType.replace('$', '')
            t = '$'
          }
        } else {
          text = valueType + ' ' + text;
        }
        console.log({text})
        const purchaseMatch = text.match(/w\/purchase\/\S+(?:\s+\d+(?:\.\d+)?)?/);
        const purchaseText = purchaseMatch ? `${purchaseMatch[0]}` : '';
        let amount = null;
        if (purchaseText) {
          // if purchase text like w/purchase/any <amount> extract amount
          const amountMatch = purchaseText.match(/w\/purchase\/(any|\$)?\s*(\d+(\.\d+)?)/);
          amount = amountMatch ? amountMatch[2] : '';
          purchaseAmount.setValue(amount);
        }
        let coupon = ALL_COUPON_TYPES_TEXT_PREFIXED.find(item => {
          const itemValue = item.id || item.title || item;
          return text.includes(itemValue)
        });
        coupon = coupon ? (coupon.id || coupon.title || coupon) : '';
        let free = text.replace(purchaseText, '').replace(coupon, '').trim();
        val.setValue(v);
        type.setValue(t);
        couponText.setValue(coupon);
        freeText.setValue(free);
      }
    }
    return () => { };
  }, []);

  return (
    <div className={`${className} mt-1 p-2`}>
      <Title>Offer Text Builder</Title>
      <Container className="mt-2">
        <div style={{ width: 60, marginRight: 20 }}>
          <Input2
            label="Buy"
            type="float"
            value={buy.value}
            onChange={(e) => {
              buy.setValue(e);
              handleUpdateValue(
                e,
                get.value,
                val.value,
                type.value,
                freeText.value, 
                couponText.value);
            }}
          />
        </div>
        <div style={{ width: 60, marginRight: 20 }}>
          <Input2
            label="Get"
            type="float"
            value={get.value}
            onChange={(e) => {
              get.setValue(e);
              handleUpdateValue(
                buy.value, 
                e, 
                val.value, 
                type.value, 
                freeText.value, 
                couponText.value);
            }}
          />
        </div>

        <div style={{ width: 120, marginRight: 20 }}>
          {amountDataTypes.includes(type.value) ? (
            <DecimalInput
              label="Value"
              value={val.value}
              onChange={(e) => {
                if (type.value !== 'Free') {
                  val.setValue(e);
                  handleUpdateValue(
                    buy.value, 
                    get.value, 
                    e, 
                    type.value, 
                    freeText.value, 
                    couponText.value
                  );
                }
              }}
            />
          ) : (
            <Input2
              label="Value"
              type="float"
              value={val.value}
              onChange={(e) => {
                if (type.value !== 'Free') {
                  val.setValue(e);
                  handleUpdateValue(
                    buy.value, 
                    get.value, 
                    e, 
                    type.value, 
                    freeText.value, 
                    couponText.value
                  );
                }
              }}
            />
          )}
        </div>

        <div className="ml-auto" style={{ width: 120 }}>
          <DropDown2
            label="Type"
            data={typeData}
            width={120}
            value={type.value}
            onChange={(e) => {
              type.setValue(e);
              console.log(buy.value, get.value, val.value, e, freeText.value);
              handleUpdateValue(
                buy.value, 
                get.value, 
                val.value, 
                e, 
                freeText.value, 
                couponText.value
              );
            }}
          />
        </div>
      </Container>
      <Container>
        <div className="mt-auto" style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <Tag style={{
            padding: '4px'
          }} color={value.includes('w/purchase/') ? 'blue-inverse' : ''} onClick={
            () => {
              if (value.includes('w/purchase/')) {
                onChange(value.replace(/w\/purchase\/\S*/g, ''));
              } else {
                onChange(`${value ? `${value} ` : ""}w/purchase/`);
              }
            }
          }>w/purchase/</Tag>
          <Select
            style={{ width: 120, marginLeft: 10, marginRight: 10 }}
            disabled={!value.includes('w/purchase/')}
            value={
              value.includes('w/purchase/$')
                ? '$' : value.includes('w/purchase/any')
                  ? 'any' : value.includes('w/purchase/') ? 'QTY' : null
            }
            onChange={(e) => {
              if (e === 'QTY') {
                if (value.includes('w/purchase/$')) {
                  const base = value.split('w/purchase/$')[0].trim();
                  const other = value.split('w/purchase/$')[1];
                  onChange(`${base} w/purchase/0 ${other ? other.replace(/^\$?\d+(?:\.\d+)?/, '').trim() : ''}`.trim());
                  purchaseAmount.setValue('0');
                } else if (value.includes('w/purchase/any')) {
                  const base = value.split('w/purchase/any')[0].trim();
                  const other = value.split('w/purchase/any')[1];
                  onChange(`${base} w/purchase/0 ${other ? other.replace(/^\d+(?:\.\d+)?/, '').trim() : ''}`.trim());
                  purchaseAmount.setValue('0');
                }
              } else if (e === 'any') {
                if (value.includes('w/purchase/$')) {
                  const base = value.split('w/purchase/$')[0].trim();
                  const other = value.split('w/purchase/$')[1];
                  onChange(`${base} w/purchase/any 0 ${other ? other.replace(/^\$?\d+(?:\.\d+)?/, '').trim() : ''}`.trim());
                  purchaseAmount.setValue('0');
                } else if (value.includes('w/purchase/')) {
                  const base = value.split('w/purchase/')[0].trim();
                  const other = value.split('w/purchase/')[1].trim();
                  onChange(`${base} w/purchase/any 0 ${other ? other.replace(/^\d+(?:\.\d+)?/, '').trim() : ''}`.trim());
                  purchaseAmount.setValue('0');
                }
              } else if (e === '$') {
                if (value.includes('w/purchase/any')) {
                  const base = value.split('w/purchase/any')[0].trim();
                  const other = value.split('w/purchase/any')[1].trim();
                  onChange(`${base} w/purchase/$0.00 ${other ? other.replace(/^\d+(?:\.\d+)?/, '').trim() : ''}`.trim());
                  purchaseAmount.setValue('0.00');
                } else if (value.includes('w/purchase/')) {
                  const base = value.split('w/purchase/')[0].trim();
                  const other = value.split('w/purchase/')[1].trim();
                  onChange(`${base} w/purchase/$0.00 ${other ? other.replace(/^\d+(?:\.\d+)?/, '').trim() : ''}`.trim());
                  purchaseAmount.setValue('0.00');
                } else if (!value.includes('w/purchase/$')) {
                  onChange(`${value} w/purchase/$0.00`);
                  purchaseAmount.setValue('0.00');
                }
              }
            }}
          >
            <Select.Option value="QTY">QTY</Select.Option>
            <Select.Option value="$">$</Select.Option>
            <Select.Option value="any">any</Select.Option>
          </Select>
        </div>
        {
          value.includes('w/purchase/$') ?
            <DecimalInput
              label="Amount"
              value={(() => {
                const splitVal = value.split("w/purchase/$")[1];
                const match = splitVal && splitVal.match(/^\d+(?:\.\d+)?/);
                return match && match[0] ? match[0] : '';
              })()}
              onChange={(e) => {
                const base = value.split('w/purchase/$')[0].trim();
                const other = value.split('w/purchase/$')[1].trim();
                onChange(`${base} w/purchase/$${e} ${other ? other.replace(/^\d+(?:\.\d+)?/, '').trim() : ''}`.trim());
                purchaseAmount.setValue(e);
              }}
            />
            : value.includes('w/purchase/any') ?
              <Input2
                label="Amount"
                type="float"
                value={purchaseAmount.value}
                onChange={(e) => {
                  const base = value.split('w/purchase/any')[0].trim();
                  const other = value.split('w/purchase/any')[1].trim();
                  console.log({base, other});
                  onChange(`${base} w/purchase/any ${e} ${other ? other.replace(/^\d+(?:\.\d+)?/, '').trim() : ''}`.trim());
                  purchaseAmount.setValue(e);
                }}
              />
            : value.includes('w/purchase/') ?
              <Input2
                label="Amount"
                type="int"
                value={purchaseAmount.value}
                onChange={(e) => {
                  const base = value.split('w/purchase/')[0].trim();
                  const other = value.split('w/purchase/')[1].trim();
                  onChange(`${base} w/purchase/${e} ${other ? other.replace(/^\d+(?:\.\d+)?/, '').trim() : ''}`.trim());
                  purchaseAmount.setValue(e);
                }}
              />
              : null
        }
      </Container>
      <Container>
        <div className="ml-auto" style={{ width: "50%" }}>
          <AutocompleteFreeText
            className="w-100"
            label="Free Text"
            value={freeText.value}
            data={SAVE_OFFER_PREDICTIVE_TEXT}
            onChange={e => {
              freeText.setValue(e);
              handleUpdateValue(
                buy.value,
                get.value,
                val.value,
                type.value,
                e,
                couponText.value
              );
            }}
          />
        </div>
        <div className="ml-1" style={{ width: "50%" }}>
          <DropDown2
            data={ALL_COUPON_TYPES_TEXT_PREFIXED}
            value={couponText.value}
            onChange={e => {
              // Filter out w/purchase/ patterns before setting (including w/purchase/any {amount})
              const filteredText = e.replace(/w\/purchase\/\S+(?:\s+\d+(?:\.\d+)?)?/g, '');
              couponText.setValue(filteredText)
              handleUpdateValue(
                buy.value,
                get.value,
                val.value,
                type.value,
                freeText.value,
                filteredText
              );
            }}
            label='Coupon'
          />
        </div>
      </Container>
    </div>
  );
};

const Title = styled.div`
  color: #66c0e1;
  font-size: 16px;
`;
const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  padding: 8px;
  display: flex;
`;
